import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { WorkItemList, WorkItemStateEnum } from "../../../store/types/work.types";
import { isOverdue } from "../../../utils/activityHelpers";
import ActivityLink from "../../activity-link/ActivityLink";
import VisualActionDialog from "../../next-action/VisualActionDialog";
import WorkItemListItem from "../../workitem/WorkItemListItem";

interface NextActivityCardProps {
  workItems: WorkItemList[];
  customerNo: number;
  workId: number;
  workIsOpen: boolean;
}

const getOldestActiveItem = (items: WorkItemList[]): WorkItemList | null => {
  const active = items.filter((i) => i.State === WorkItemStateEnum.Active);
  if (active.length === 0) return null;

  return [...active].sort(
    (a, b) =>
      new Date(a.ScheduledTo).getTime() - new Date(b.ScheduledTo).getTime()
  )[0];
};

const NextActivityCard = ({ workItems, customerNo, workId, workIsOpen }: NextActivityCardProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const item = getOldestActiveItem(workItems);

  if (!item) {
    if (!workIsOpen) return null;

    return (
      <>
        <Box
          sx={{
            p: 2.5,
            borderRadius: 2,
            border: "1px dashed",
            borderColor: "warning.light",
            bgcolor: "warning.50",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            Inga planerade aktiviteter på detta ärende
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            onClick={() => setDialogOpen(true)}
            sx={{ borderRadius: 2 }}
          >
            Skapa aktivitet
          </Button>
        </Box>
        <VisualActionDialog
          open={dialogOpen}
          customerNo={customerNo}
          workId={workId}
          onClose={() => setDialogOpen(false)}
        />
      </>
    );
  }

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ mb: 0.5, display: "block" }}>
        Nästa aktivitet
      </Typography>
      <ActivityLink
        to={`/activity/${item.Id}`}
        customerNo={customerNo}
        workItemNo={item.Id}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <WorkItemListItem
          workItemType={item.Type}
          title={item.Name}
          description={item.Description}
          date={item.ScheduledTo}
          customerName={item.Customer?.Name || ""}
          resultData={item.Result}
          workId={item.WorkId}
          showAction={false}
          isActive={item.State === WorkItemStateEnum.Active}
          isOverdue={isOverdue(item)}
        />
      </ActivityLink>
    </Box>
  );
};

export default NextActivityCard;
